import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import rosterAndlabour from '@/components/rosterAndLabour/index'
import roster from '@/components/rosterAndLabour/roster'
import labour from '@/components/rosterAndLabour/labour'
import employee from '@/components/rosterAndLabour/employee_new'
import area from '@/components/rosterAndLabour/area'
import tandaArea from '@/components/rosterAndLabour/tandaArea'

import appAccount from '@/components/rosterAndLabour/app'

import fee from '@/components/fees/fee'
import setting from '@/components/setting/setting'
import setInformation from '@/components/setting/setInformation'
import setholiday from '@/components/setting/holiday'
import setRent from '@/components/setting/setrent'
import stream from '@/components/setting/stream'
import setCogs from '@/components/setting/cogs'
import target from '@/components/setting/target'
import setBudgetingTool from '@/components/setting/budgetingTool'

// import holidays from '@/components/setting/holidays'
import manualStocktakesCOGs from '@/components/setting/manualStocktakesCOGs'
import setProfitLoss from '@/components/setting/setProfitLoss'

import download from '@/components/login/download'

import venueselect from '@/components/login/venue'
import forget from '@/components/login/forget'
import dashboard from '@/components/dashboard/index'
import DashboardLabour from '@/components/dashboard/weeklyLabour'
import venue from '@/components/venue/index'
import revenue from '@/components/revenue/index'
import revenueForcasting from '@/components/revenue/forcasting'
import productCategories from '@/components/revenue/productCategories'
import terminals from '@/components/revenue/terminals'
import accountingTable from '@/components/revenue/accountingTable'
import revenueGroup from '@/components/revenue/revenueGroup'
import income from '@/components/revenue/income'
import demo from '@/components/common/demo'

import welcome from '@/components/register/welcome'
import general from '@/components/register/general'
import time from '@/components/register/time'
import rent from '@/components/register/rent'
import pay from '@/components/register/pay'
import mobileApp from '@/components/register/appAccount'
import success from '@/components/register/success'
import thankYouPro from '@/components/register/thankYouPro'
import thankYouLite from '@/components/register/thankYouLite'

import help from '@/components/help/index'

import login from '@/components/login/login'
import policy from '@/components/login/policy'
import term from '@/components/login/term'
import eodReport from '@/components/report/eod'
import emailContent from '@/components/report/emailContent'
import eos from '@/components/eos/eos'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        requireAuth: true,
        keepAlive: false
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: dashboard,
          meta:{
            requireAuth: true,
            keepAlive: false
          },
        },
        {
          path: '/labour',
          name: 'labours',
          component: DashboardLabour,
          meta:{
            requireAuth: true,
            keepAlive: false
          },
        },
        {
          path: '/venue',
          name: 'venue',
          component: venue,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/revenue',
          name: 'revenue',
          component: revenue,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/revenue-forcasting',
          name: 'revenueForcasting',
          component: revenueForcasting,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/product-categories',
          name: 'productCategories',
          component: productCategories,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/terminals',
          name: 'terminals',
          component: terminals,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: ' /accounting-categories',
          name: ' accountingTable',
          component: accountingTable,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
       
        {
          path: '/revenue-group',
          name: 'revenueGroup',
          component: revenueGroup,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/income',
          name: 'income',
          component: income,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },
        {
          path: '/help',
          name: 'help',
          component: help,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },

        {
          path: '/eos',
          name: 'eos',
          component: eos,
          meta:{
            requireAuth: true,
            keepAlive: false
          }
        },

        { //roster & labour
          path:'/rosterAndlabour',
          name:'rosterAndlabour',
          component:rosterAndlabour,
          children:[
            {
              path: '/rosterAndlabourroster',
              name: 'roster',
              component: roster,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path: '/rosterAndlabourlabour',
              name: 'labour',
              component: labour,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path: '/rosterAndlabourarea',
              name: 'area',
              component: area,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path: '/rosterAndtandaarea',
              name: 'tandaArea',
              component: tandaArea,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path: '/rosterAndemployee',
              name: 'employee',
              component: employee,
              meta: {
                keepAlive: false
              }                   
            },
            // 沙箱才有这个
            {
              path: '/rosterAndapp',
              name: 'rosterAndapp',
              component: appAccount,
              meta: {
                keepAlive: false
              }                   
            }

          ],
          meta: {
            keepAlive: false
          }                   
        },
        { // fee
          path:'/fees',
          name:'fees',
          component:fee,
          meta: {
            keepAlive: false
          }                   
        },
        { // setting
          path:'/setting',
          name:'setting',
          component:setting,
          children:[
            {
              path:'/setInformation',
              name:'setInformation',
              component:setInformation,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/setRent',
              name:'setRent',
              component:setRent,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/stream',
              name:'stream',
              component:stream,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/target',
              name:'target',
              component:target,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/setBudgetingTool',
              name:'setBudgetingTool',
              component:setBudgetingTool,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/holidays',
              name:'holidays',
              // component:holidays
              component:setholiday,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/manualStocktakesCOGs',
              name:'manualStocktakesCOGs',
              component:manualStocktakesCOGs,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/setProfitLoss',
              name:'setProfitLoss',
              component:setProfitLoss,
              meta: {
                keepAlive: false
              }                   
            },
            {
              path:'/cogs',
              name:'cogs',
              component:setCogs,
              meta: {
                keepAlive: false
              }                   
            }
          ],
          meta: {
            keepAlive: false
          }                   
       },

      ],
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/report/eod/:id',
      name: 'eod',
      component: eodReport,
      meta:{
        requireAuth: true,
        keepAlive: false
      },       
      // children: [
      //   {
      //     path: '/eod',
      //     name: 'eod',
      //     component: eodReport,
      //     meta:{
      //       requireAuth: true,
      //       keepAlive: false
      //     },
      //   },
      // ],     
    },
    {
      path: '/report/eod/email/:id',
      name: 'emailContent',
      component: emailContent,
      meta: {
        requireAuth: true,
        keepAlive: false
      }
    },
    {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/venueselect',
      name: 'venueselect',
      component: venueselect,
      meta: {
        keepAlive: false
      }
    },

    {
      path: '/video',
      name: 'video',
      component: demo,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: welcome,
      meta: {
        keepAlive: false,
        restart: true
      }
    },
    {
      path: '/welcome/:type',
      name: 'welcome',
      component: welcome,
      meta: {
        keepAlive: false,
        restart: true
      }
    },
    {
      path: '/register',
      name: 'general',
      component: general,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/time',
      name: 'time',
      component: time,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/rent',
      name: 'rent',
      component: rent,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/success',
      name: 'success',
      component: success,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/mobileApp',
      name: 'mobileApp',
      component: mobileApp,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/privacy-policy',
      name: 'policy',
      component: policy,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/terms-of-use',
      name: 'term',
      component: term,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/peiso-pro-thank-you-page',
      name: 'thankYouPro',
      component: thankYouPro,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/peiso-lite-thank-you-page',
      name: 'thankYouLite',
      component: thankYouLite,
      meta: {
        keepAlive: false
      }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js